module.exports = __webpack_public_path__ + "img/Slovakia_GP1_Green circular academy.23781675.png";